import LiveWeatherCenter from './live_weather_center';

export default LiveWeatherCenter;



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/index.js